<template>
  <div class="contact-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="section-container">
        <h1 class="page-header__title">{{ t.title }}</h1>
        <div class="page-header__breadcrumb">
          <router-link to="/">Home</router-link>
          <span>/</span>
          <span>{{ t.crumb }}</span>
        </div>
      </div>
    </div>

    <!-- Contact Content -->
    <section class="section">
      <div class="section-container">
        <div class="contact-grid animate-on-scroll">
          <!-- Contact Info -->
          <div class="contact-info">
            <span class="badge-label">
              <span class="badge-label__dot"></span>
              {{ t.info.badge }}
            </span>
            <h2>{{ t.info.title.pre }}<span class="text-gradient">{{ t.info.title.hl }}</span>{{ t.info.title.post }}</h2>
            <p class="contact-info__desc">{{ t.info.desc }}</p>

            <div class="contact-info__cards">
              <div class="contact-info__card">
                <div class="contact-info__card-icon"><i class="fa fa-map-marker"></i></div>
                <div>
                  <strong>{{ t.info.address }}</strong>
                  <p>PT. Mira Bisa Berteknologi<br />Citra Maja City, Cluster Vimala M16/01<br />Maja Baru, Lebak Banten
                    42382</p>
                </div>
              </div>
              <div class="contact-info__card">
                <div class="contact-info__card-icon"><i class="fa fa-phone"></i></div>
                <div>
                  <strong>{{ t.info.phone }}</strong>
                  <p><a class="custom-link" href="https://wa.me/628114938580">+62 8114938580</a></p>
                </div>
              </div>
              <div class="contact-info__card">
                <div class="contact-info__card-icon"><i class="fa fa-envelope"></i></div>
                <div>
                  <strong>{{ t.info.email }}</strong>
                  <p><a class="custom-link" href="mailto:info@miraverse.id">info@miraverse.id</a></p>
                </div>
              </div>
            </div>

            <!-- <div class="contact-info__social">
              <h4>Sosial Media</h4>
              <div class="contact-info__social-links">
                <a href="https://www.twitter.com" target="_blank" class="social-link"><i class="fa fa-twitter"></i></a>
                <a href="https://www.facebook.com" target="_blank" class="social-link"><i
                    class="fa fa-facebook-f"></i></a>
                <a href="https://www.youtube.com" target="_blank" class="social-link"><i class="fa fa-youtube"></i></a>
                <a href="https://www.instagram.com" target="_blank" class="social-link"><i
                    class="fa fa-instagram"></i></a>
                <a href="https://www.linkedin.com" target="_blank" class="social-link"><i
                    class="fa fa-linkedin"></i></a>
              </div>
            </div> -->
          </div>

          <!-- Contact Form -->
          <div class="contact-form-wrap">
            <div class="contact-form-card">
              <h3>{{ t.form.title }}</h3>
              <p>{{ t.form.intro }}</p>

              <!-- Status Banner -->
              <transition name="fade">
                <div v-if="submitStatus" :class="['form-status', `form-status--${submitStatus.type}`]">
                  <i :class="submitStatus.type === 'success' ? 'fa fa-check-circle' : 'fa fa-exclamation-circle'"></i>
                  {{ t.status[submitStatus.key] }}
                </div>
              </transition>

              <form @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label for="name">{{ t.form.name.label }}</label>
                  <input v-model="form.name" type="text" id="name" :placeholder="t.form.name.placeholder"
                    :class="['form-input', { 'form-input--error': errors.name }]" @input="clearError('name')" />
                  <span v-if="errors.name" class="form-error">{{ t.errors.name[errors.name] }}</span>
                </div>
                <div class="form-group">
                  <label for="email">{{ t.form.email.label }}</label>
                  <input v-model="form.email" type="email" id="email" :placeholder="t.form.email.placeholder"
                    :class="['form-input', { 'form-input--error': errors.email }]" @input="clearError('email')" />
                  <span v-if="errors.email" class="form-error">{{ t.errors.email[errors.email] }}</span>
                </div>
                <div class="form-group">
                  <label for="subject">{{ t.form.subject.label }}</label>
                  <input v-model="form.subject" type="text" id="subject" :placeholder="t.form.subject.placeholder"
                    :class="['form-input', { 'form-input--error': errors.subject }]" @input="clearError('subject')" />
                  <span v-if="errors.subject" class="form-error">{{ t.errors.subject[errors.subject] }}</span>
                </div>
                <div class="form-group">
                  <label for="message">{{ t.form.message.label }}</label>
                  <textarea v-model="form.message" id="message" rows="4" :placeholder="t.form.message.placeholder"
                    :class="['form-input', { 'form-input--error': errors.message }]"
                    @input="clearError('message')"></textarea>
                  <span v-if="errors.message" class="form-error">{{ t.errors.message[errors.message] }}</span>
                </div>
                <button type="submit" class="btn-primary-custom" style="width: 100%; justify-content: center;"
                  :disabled="isSubmitting">
                  <span v-if="isSubmitting" class="btn-spinner"></span>
                  {{ isSubmitting ? t.form.sending : t.form.submit }}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <!-- <section class="map-section">
      <div id="map"></div>
    </section> -->
  </div>
</template>

<script>
import L from 'leaflet'
import markerIcon from '@/../node_modules/leaflet/dist/images/marker-icon.png'
import copy from '@/locales/contact'

export default {
  name: 'ContactPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      errors: {},
      isSubmitting: false,
      // { type, key } where key names a message in the locale's `status` group
      submitStatus: null,
    }
  },
  computed: {
    t() {
      return copy[this.$lang]
    },
  },
  mounted() {
    this.initScrollAnimations()
    if (this.$route.query.subject) {
      this.form.subject = String(this.$route.query.subject)
    }
    // this.$nextTick(() => {
    //   this.initMap()
    // })
  },
  methods: {
    initMap() {
      const map = L.map('map').setView([-6.350932470831206, 106.39100776837007], 13)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(map)

      L.Marker.prototype.setIcon(L.icon({
        iconUrl: markerIcon,
        iconAnchor: [10, 0],
        popupAnchor: [2, 0]
      }))
      L.marker([-6.350932470831206, 106.39100776837007]).addTo(map)
        .bindPopup('PT. Mira Bisa Berteknologi')
        .openPopup()
    },
    initScrollAnimations() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { entry.target.classList.add('animated') }
          })
        },
        { threshold: 0.1 }
      )
      this.$nextTick(() => {
        document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el))
      })
    },
    clearError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field)
      }
    },
    // Errors are codes looked up in the locale's `errors` group
    validateForm() {
      const errors = {}

      // Name
      if (!this.form.name.trim()) {
        errors.name = 'required'
      } else if (this.form.name.trim().length < 2) {
        errors.name = 'tooShort'
      }

      // Email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!this.form.email.trim()) {
        errors.email = 'required'
      } else if (!emailRegex.test(this.form.email.trim())) {
        errors.email = 'invalid'
      }

      // Subject
      if (!this.form.subject.trim()) {
        errors.subject = 'required'
      } else if (this.form.subject.trim().length < 3) {
        errors.subject = 'tooShort'
      }

      // Message
      if (!this.form.message.trim()) {
        errors.message = 'required'
      } else if (this.form.message.trim().length < 10) {
        errors.message = 'tooShort'
      }

      this.errors = errors
      return Object.keys(errors).length === 0
    },
    async handleSubmit() {
      this.submitStatus = null

      if (!this.validateForm()) return

      this.isSubmitting = true
      try {
        // 1. Get a short-lived token
        const tokenRes = await fetch('/api/token')
        const tokenData = await tokenRes.json()

        if (!tokenRes.ok || !tokenData.token) {
          this.submitStatus = { type: 'error', key: tokenRes.status === 429 ? 'tooMany' : 'tokenFailed' }
          return
        }

        // 2. Submit the form with the token
        const res = await fetch('/api/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-token': tokenData.token,
          },
          body: JSON.stringify({
            name: this.form.name.trim(),
            email: this.form.email.trim(),
            subject: this.form.subject.trim(),
            message: this.form.message.trim(),
          }),
        })

        // The server replies in Indonesian only, so its status code picks a localized message
        if (res.ok) {
          this.submitStatus = { type: 'success', key: 'sent' }
          this.form = { name: '', email: '', subject: '', message: '' }
        } else if (res.status === 429) {
          this.submitStatus = { type: 'error', key: 'tooMany' }
        } else if (res.status >= 500) {
          this.submitStatus = { type: 'error', key: 'sendFailed' }
        } else {
          this.submitStatus = { type: 'error', key: 'failed' }
        }
      } catch {
        this.submitStatus = { type: 'error', key: 'network' }
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.text-gradient {
  background: linear-gradient(135deg, #6C2973, #C73468);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.contact-info__desc {
  color: $text-body;
  margin-top: 12px;
  margin-bottom: 32px;
  line-height: 1.8;
}

.contact-info__cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-info__card {
  display: flex;
  gap: 16px;
  padding: 20px;
  border-radius: 14px;
  background: rgba(108, 41, 115, 0.04);
  border: 1px solid rgba(108, 41, 115, 0.08);

  strong {
    display: block;
    font-size: 0.95rem;
    color: $text-dark;
    margin-bottom: 4px;
  }

  p {
    font-size: 0.88rem;
    color: $text-body;
    line-height: 1.6;
    margin: 0;
  }
}

.contact-info__card-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #6C2973, #C73468);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1rem;
  flex-shrink: 0;
}

.contact-info__social {
  margin-top: 28px;

  h4 {
    font-size: 1rem;
    margin-bottom: 12px;
  }
}

.contact-info__social-links {
  display: flex;
  gap: 10px;
}

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(108, 41, 115, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6C2973;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: linear-gradient(135deg, #6C2973, #C73468);
    color: #fff;
    transform: translateY(-2px);
  }
}

.contact-form-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 40px rgba(108, 41, 115, 0.1);
  border: 1px solid rgba(108, 41, 115, 0.06);

  h3 {
    margin-bottom: 6px;
  }

  >p {
    color: $text-muted;
    font-size: 0.9rem;
    margin-bottom: 28px;
  }
}

.form-group {
  margin-bottom: 18px;

  label {
    display: block;
    font-size: 0.88rem;
    font-weight: 600;
    color: $text-dark;
    margin-bottom: 6px;
  }
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(108, 41, 115, 0.12);
  border-radius: 10px;
  font-size: 0.92rem;
  font-family: 'Inter', sans-serif;
  color: $text-dark;
  background: rgba(108, 41, 115, 0.02);
  transition: all 0.25s ease;
  outline: none;

  &:focus {
    border-color: #6C2973;
    box-shadow: 0 0 0 3px rgba(108, 41, 115, 0.08);
  }

  &::placeholder {
    color: $text-muted;
  }
}

.form-input--error {
  border-color: #e74c3c;
  background: rgba(231, 76, 60, 0.03);

  &:focus {
    border-color: #e74c3c;
    box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);
  }
}

.form-error {
  display: block;
  color: #e74c3c;
  font-size: 0.8rem;
  margin-top: 5px;
  animation: slideDown 0.2s ease;
}

textarea.form-input {
  resize: vertical;
  min-height: 100px;
}

/* Status Banner */
.form-status {
  padding: 14px 18px;
  border-radius: 10px;
  margin-bottom: 20px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 10px;

  i {
    font-size: 1.1rem;
  }
}

.form-status--success {
  background: rgba(39, 174, 96, 0.08);
  border: 1px solid rgba(39, 174, 96, 0.2);
  color: #1e8449;
}

.form-status--error {
  background: rgba(231, 76, 60, 0.08);
  border: 1px solid rgba(231, 76, 60, 0.2);
  color: #c0392b;
}

/* Button Spinner */
.btn-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin-right: 8px;
}

/* Animations */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.map-section {
  margin-top: -1px;

  #map {
    height: 400px;
    width: 100%;
  }
}

.custom-link {
  color: inherit;
}

@media (max-width: 991px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}
</style>
